import React from "react";
import { useSelector } from "react-redux";
import SurveyListHeader from "../../../component/layout/MainHeader";
import SurveyListSidebar from "../../../component/layout/MainSidebar";
import AgentAssistantWidget from "./agent/AgentAssistantWidget";

export default function AgentStudio() {
  const apiUrl = process.env.REACT_APP_NODE_API_URL;
  const { userData } = useSelector((state) => state.userDataHeader);
  const adminUserName = userData?.[0]?.name || "Admin";

  return (
    <div className="d-flex flex-column main-outer-wrapper main-site-wrapper">
      <SurveyListHeader />
      <div id="viewport" className="d-flex">
        <SurveyListSidebar />
        <div className="flex-grow-1 dashboard-page-outer p-4">
          <h1 className="h4 mb-2">Create your calculator</h1>
          <p className="text-muted mb-4">
            Turn an idea into a calculator. Define the logic, review the draft, and build when you’re ready.
          </p>
          <AgentAssistantWidget
            apiUrl={apiUrl}
            mode="builder"
            userName={adminUserName}
            enabled
            embedded
            defaultOpen
            bridgeHandlers={{}}
          />
        </div>
      </div>
    </div>
  );
}
